class
SearchResultsController {
  constructor() {
    "ngInject";
  }
}

export default
SearchResultsController;
